import { render, staticRenderFns } from "./SmartClasses.vue?vue&type=template&id=576543bb"
import script from "./SmartClasses.vue?vue&type=script&lang=js"
export * from "./SmartClasses.vue?vue&type=script&lang=js"
import style0 from "./SmartClasses.vue?vue&type=style&index=0&id=576543bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports